import React, { useCallback, useContext, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';

import { collection, getDocs, doc, setDoc ,query, where} from "firebase/firestore";
import { db } from '../../Firebase/FirebaseConfig';
import { createUserWithEmailAndPassword , deleteUser} from "firebase/auth";
import { secondaryAuth } from '../../Firebase/FirebaseConfig';

import Notification from '../Notification/Notification';

const states = [
  {
    value: 'alabama',
    label: 'Alabama'
  },
  {
    value: 'new-york',
    label: 'New York'
  },
  {
    value: 'san-francisco',
    label: 'San Francisco'
  }
];

const FormUser = (props) => {
    const {set_view, onCreate} = props;
    const [loading_create, set_loading_create] = useState(false);

    const [open_notification, set_open_notification] = useState(false);
    const [message_notification, set_message_notification] = useState('');
    const [severity_notification, set_severity_notification] = useState('');

    const openNotification = (message_, severity_)=>{
        set_message_notification(message_);
        set_severity_notification(severity_);
        set_open_notification(true);
        set_open_notification(false);
    }

    const formik = useFormik({
        initialValues: {
          nombre: '',
          cedula:'',
          telefono:'',
          usuario: '',
          contrasena: '',
        },
        validationSchema: Yup.object({
            nombre: Yup
                .string()
                .max(255)
                .required(
                'Por favor ingresa el nombre completo del usuario'),
            cedula: Yup
                .number()
                .min(1)
                .required(
                'Por favor ingresa el documento del usuario sin signos de puntuación'),
            telefono: Yup
                .number()
                .min(1)
                .required(
                'Por favor ingresa el número de télefono del usuario'),
            usuario: Yup
                .string()
                .email(
                'Por favor ingresa un correo electrónico válido')
                .max(255)
                .required(
                'Por favor ingresa un correo electrónico válido'),
            contrasena: Yup
                .string()
                .min(6, 'La contraseña debe tener al menos 6 caracteres')
                .max(255)
                .required(
                'Se requiere la contraseña')
        }),
        // onSubmit: (formData) => console.log(formData)
        onSubmit: async (values, { resetForm }) => {
            set_loading_create(true);
            createUserWithEmailAndPassword(secondaryAuth, values.usuario, values.contrasena)
            .then((userCredential) => {
                // Signed in
                const user = userCredential.user;
                console.log('usuario creado', user)
                console.log("User " + userCredential.user.uid + " created successfully!");
                //I don't know if the next statement is necessary 
                

                const new_user = {rol: 'usuario',
                    nombre: values.nombre, 
                    cedula: values.cedula, 
                    telefono:values.telefono, 
                    usuario: values.usuario, 
                    contrasena: values.contrasena,
                    respuestas:[], 
                    video:'', 
                    finish: false
                }

                setDoc(doc(db, "usuarios_app", userCredential.user.uid), new_user).then(()=>{

                    set_loading_create(false);
                    resetForm();
                    onCreate();
                    openNotification('Usuario creado correctamente', 'success');

                    window.location.href = `mailto:${new_user.usuario}
                              ?subject=Proceso de Selección EFICACIA 
                              &body=¡Hola! Te invitamos a participar en el proceso de selección para la organización EFICACIA para el cargo Analista de Selección de Personal.
                              %0D%0AEstamos seguros que cuentas con las habilidades y competencias para transformar vidas.
                              %0D%0APara participar debes acceder al siguiente link: https://appreclutamiento.scenariovr.co/ 
                              %0D%0A%0D%0ATus credenciales de acceso son: 
                              %0D%0AUSUARIO: ${new_user.usuario}
                              %0D%0ACONTRASEÑA: ${new_user.contrasena}

                              %0D%0A%0D%0A¡Te esperamos!`

                }).catch((error) => {
                    const errorCode = error.code;
                    const errorMessage = error.message;
                    
                    //Eliminar el usuario de autenticación
                    deleteUser(user).then(() => {

                    }).catch((error) => {
                        
                    });

                    openNotification('Algo ha salido mal, no se pudo crear el usuario ' + errorMessage, 'error');
                    // alert('Algo ha salido mal, no se pudo crear el usuario ' + ': '+ errorMessage);
                    set_loading_create(false);
                });

                secondaryAuth.signOut();
                
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                // alert('Algo ha salido mal, no se pudo crear el usuario ' + ': '+ errorMessage);
                openNotification('Algo ha salido mal, no se pudo crear el usuario ' + errorMessage, 'error');
                set_loading_create(false);
            });
        }
    });


    return (
        <>
        <form
            autoComplete="off"
            onSubmit={formik.handleSubmit}
            // noValidate
            // {...props}
        >
        <Card>
            <CardHeader
            subheader="Completa todos los campos"
            title="Creación de usuarios"
            >
                
            </CardHeader>
            <Divider />
            <CardContent>
            <Grid
                container
                spacing={3}
            >
                <Grid
                    item
                    md={6}
                    xs={12}
                >
                    <TextField
                        error={Boolean(formik.touched.nombre && formik.errors.nombre)}
                        fullWidth
                        helperText={formik.touched.nombre && formik.errors.nombre}
                        label="Nombre"
                        margin="normal"
                        name="nombre"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        type="text"
                        value={formik.values.nombre}
                        variant="outlined"
                    />
                </Grid>
                <Grid
                    item
                    md={6}
                    xs={12}
                >
                    <TextField
                        error={Boolean(formik.touched.cedula && formik.errors.cedula)}
                        fullWidth
                        helperText={formik.touched.cedula && formik.errors.cedula}
                        label="Cédula de ciudadanía"
                        margin="normal"
                        name="cedula"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        type="number"
                        value={formik.values.cedula}
                        variant="outlined"
                    />
                </Grid>
                <Grid
                item
                md={6}
                xs={12}
                >
                <TextField
                    error={Boolean(formik.touched.telefono && formik.errors.telefono)}
                    fullWidth
                    helperText={formik.touched.telefono && formik.errors.telefono}
                    label="Teléfono"
                    margin="normal"
                    name="telefono"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    type="number"
                    value={formik.values.telefono}
                    variant="outlined"
                />
                </Grid>
                <Grid
                    item
                    md={6}
                    xs={12}
                >
                    <TextField
                        error={Boolean(formik.touched.usuario && formik.errors.usuario)}
                        fullWidth
                        helperText={formik.touched.usuario && formik.errors.usuario}
                        label="Correo electrónico"
                        margin="normal"
                        name="usuario"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        type="email"
                        value={formik.values.usuario}
                        variant="outlined"
                    />
                </Grid>
                <Grid
                    item
                    md={6}
                    xs={12}
                >
                    <TextField
                        error={Boolean(formik.touched.contrasena && formik.errors.contrasena)}
                        fullWidth
                        helperText={formik.touched.contrasena && formik.errors.contrasena}
                        label="Contraseña"
                        margin="normal"
                        name="contrasena"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        type="text"
                        value={formik.values.contrasena}
                        variant="outlined"
                    />
                </Grid>
                {/* <Grid
                    item
                    md={6}
                    xs={12}
                >
                    <TextField
                        fullWidth
                        label="Select State"
                        name="state"
                        onChange={handleChange}
                        required
                        select
                        SelectProps={{ native: true }}
                        value={values.state}
                        variant="outlined"
                    >
                        {states.map((option) => (
                        <option
                            key={option.value}
                            value={option.value}
                        >
                            {option.label}
                        </option>
                        ))}
                    </TextField>
                </Grid> */}
            </Grid>
            </CardContent>
            <Divider />
            <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                p: 2
            }}
            >
                <Button
                    disabled={loading_create}
                    onClick={()=>set_view('users')}
                    component="a"
                    startIcon={<ArrowBackIcon fontSize="small" />}
                >
                    Regresar
                </Button>

                <LoadingButton 
                    color="primary"
                    variant="contained"
                    type='submit'
                    component="span"
                    onClick={formik.handleSubmit}
                    endIcon={<AddIcon />}
                    loadingPosition="end"
                    loading={loading_create}
                >
                    {loading_create? 'creando' : 'Agregar Usuario'}
                </LoadingButton >
            </Box>
        </Card>
        </form>

        <Notification message={message_notification} severity={severity_notification} open_flag={open_notification}></Notification>
        </>
    );
};

export default FormUser;